import { render, staticRenderFns } from "./PurchaseStrategyAutocomplete.vue?vue&type=template&id=bb705e68&scoped=true&"
import script from "./PurchaseStrategyAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./PurchaseStrategyAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb705e68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
